import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "build__item"
}
const _hoisted_2 = { class: "build__main" }
const _hoisted_3 = { class: "build__title" }
const _hoisted_4 = { class: "build__desc-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ClassOrTagsLine = _resolveComponent("ClassOrTagsLine")!
  const _component_StatsLine = _resolveComponent("StatsLine")!
  const _component_BuildButtons = _resolveComponent("BuildButtons")!
  const _component_BuildAvatarPanel = _resolveComponent("BuildAvatarPanel")!
  const _directive_shiny_border = _resolveDirective("shiny-border")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.isFinishedLoading && _ctx.loadedUserData)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.isClickable && _ctx.hasLink && _ctx.item.dbId)
          ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: '/build/' + _ctx.item.dbId,
              target: "_blank",
              class: "build__link"
            }, null, 8, ["to"])), [
              [_directive_shiny_border, {
					height: 2,
					padding: 12,
					hoverRgbaColor: [37, 37, 37, 0.75],
				}],
              [_directive_ripple]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.item.data.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ClassOrTagsLine, {
              soldierClass: _ctx.item.soldierClass,
              tags: _ctx.item.tags
            }, null, 8, ["soldierClass", "tags"]),
            _createVNode(_component_StatsLine, {
              stats: _ctx.item.stats,
              source: 'build',
              size: 'compact'
            }, null, 8, ["stats"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["build__buttons-wrapper", { fullheight: !_ctx.isPreview }])
        }, [
          _createVNode(_component_BuildButtons, {
            data: _ctx.item.data,
            variation: _ctx.variation,
            build: _ctx.item
          }, null, 8, ["data", "variation", "build"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["build__footer", { fullwidth: _ctx.isPreview }])
        }, [
          _createVNode(_component_BuildAvatarPanel, {
            "photo-u-r-l": String(_ctx.loadedUserData.photoURL),
            "display-name": String(_ctx.loadedUserData.displayName),
            "email-hash": String(_ctx.loadedUserData.emailHash) || '',
            "avatar-provider": _ctx.loadedUserData.avatarProvider || 'google',
            "created-at": _ctx.item.data.createdAt,
            "updated-at": _ctx.item.data.updatedAt || null
          }, null, 8, ["photo-u-r-l", "display-name", "email-hash", "avatar-provider", "created-at", "updated-at"])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}